import React from "react";
import { MdScreenShare } from "react-icons/md";
import { Tooltip } from "@chakra-ui/tooltip";
import { IconButton } from "@chakra-ui/react";

import { useScreenShareParticipant, useVideoContext } from "hooks/session";

export const SCREEN_SHARE_TEXT = "Share Screen";
export const STOP_SCREEN_SHARE_TEXT = "Stop Sharing Screen";
export const SHARE_IN_PROGRESS_TEXT =
  "Cannot share screen when another user is sharing";
export const SHARE_NOT_SUPPORTED_TEXT =
  "Screen sharing is not supported with this browser";

interface Props {
  disabled?: boolean;
}

const ToggleScreenShareButton: React.FC<Props> = ({ disabled }: Props) => {
  const screenShareParticipant = useScreenShareParticipant();
  const { toggleScreenShare } = useVideoContext();
  const disableScreenShareButton = Boolean(screenShareParticipant);
  const isScreenShareSupported =
    // @ts-ignore
    navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia;
  const isDisabled =
    disabled || disableScreenShareButton || !isScreenShareSupported;

  let tooltipMessage = "";

  if (disableScreenShareButton) {
    tooltipMessage = SHARE_IN_PROGRESS_TEXT;
  }

  if (!isScreenShareSupported) {
    tooltipMessage = SHARE_NOT_SUPPORTED_TEXT;
  }

  return (
    <Tooltip
      title={tooltipMessage}
      placement="top"
      style={{ cursor: isDisabled ? "not-allowed" : "pointer" }}
    >
      <span>
        {/* The span element is needed because a disabled button will not emit hover events and we want to display
          a tooltip when screen sharing is disabled */}
        <IconButton
          aria-label={SCREEN_SHARE_TEXT}
          onClick={toggleScreenShare}
          disabled={isDisabled}
          icon={<MdScreenShare />}
          data-cy-share-screen
        />
      </span>
    </Tooltip>
  );
};

export default ToggleScreenShareButton;
